export default "__VITE_ASSET__uF5Hu3Sh__"